import {
  Box, Flex,
  Text,
} from '@chakra-ui/react';
import { QUARTERS, stateHighwaysPotholeRepairsLegend, TRAFFIC_LIGHT_COLOURS as COLOURS } from '@src/modules/performance/shared/constants';
import { useStateHighwaysPotholeRepairsKPI } from '@src/modules/performance/context/reports-api-hooks';
import { mapValueToColourRange, roundKpiValue } from '@src/modules/performance/shared/helpers';
import IndicatorLegend from '@src/modules/performance/components/IndicatorLegend';
import { CircleIndicator } from '@src/modules/performance/components/indicators';
import ReportHeader from './ReportHeader';

const subheader = '% completed within 24 hours';
const informationSource = {
  title: 'State Highway Pothole Repairs',
  content: [
    {
      title: '% completed within 24 hours',
      description:
  <>
    <Text fontSize="inherit" mb={2}>
      The indicator shows the colour grade for the percentage of potholes on all state highways that were repaired within 24 hours for the year to date to the end of the quarter.
      {' '}
    </Text>
    <IndicatorLegend items={stateHighwaysPotholeRepairsLegend} />
  </>,
      source:
  <Text fontSize="inherit" as="span">
    Sourced from NZTA
  </Text>,
    },
  ],
};

function StateHighwaysPotholeRepairsReportHeader({ ...rest }) {
  const { data: stateHighwaysPotholeRepairsKPI, isLoading } = useStateHighwaysPotholeRepairsKPI();
  const colour = mapValueToColourRange(stateHighwaysPotholeRepairsKPI?.percentAchievedYtd, 'stateHighwaysPotholeRepairsKpi');
  return (
    <ReportHeader
      title="State Highways Pothole Repairs"
      subtitle={subheader}
      informationSource={informationSource}
      {...rest}
    >
      {stateHighwaysPotholeRepairsKPI?.percentAchievedYtd && stateHighwaysPotholeRepairsKPI?.percentAchievedYtd !== null && !isLoading && (
      <Flex align="center" ml={4}>
        <Box mr={3}>
          <CircleIndicator
            size={60}
            colour={COLOURS[colour]}
            value={stateHighwaysPotholeRepairsKPI?.percentAchievedYtd !== null && stateHighwaysPotholeRepairsKPI?.percentAchievedYtd !== undefined ? `${roundKpiValue(stateHighwaysPotholeRepairsKPI?.percentAchievedYtd, 5, 1)}%` : null}
            isLoading={isLoading}
            padding={0}
          />
        </Box>
        <Box>
          <Text fontWeight="bold" color="gray" fontSize="sm">
            % completed within 24 hours
            <br />
            <Text as="span" fontSize="xs" color="gray">
              as at
              {' '}
              {QUARTERS.find((q) => q.id === parseInt(stateHighwaysPotholeRepairsKPI?.quarter, 10))?.label}
              {' '}
              {stateHighwaysPotholeRepairsKPI?.lockYear}
            </Text>
          </Text>
        </Box>
      </Flex>
      )}
    </ReportHeader>
  );
}

export default StateHighwaysPotholeRepairsReportHeader;
